var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadioColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99996 17.3333C14.05 17.3333 17.3333 14.05 17.3333 9.99996C17.3333 5.94987 14.05 2.66663 9.99996 2.66663C5.94987 2.66663 2.66663 5.94987 2.66663 9.99996C2.66663 14.05 5.94987 17.3333 9.99996 17.3333ZM9.99996 18.3333C14.6023 18.3333 18.3333 14.6023 18.3333 9.99996C18.3333 5.39759 14.6023 1.66663 9.99996 1.66663C5.39759 1.66663 1.66663 5.39759 1.66663 9.99996C1.66663 14.6023 5.39759 18.3333 9.99996 18.3333Z",
    fill: "#5B5C5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6877 7.97974C13.883 8.175 13.883 8.49158 13.6877 8.68685L9.52106 12.8535C9.32582 13.0488 9.00929 13.0488 8.81401 12.8536L6.31313 10.3536C6.11784 10.1583 6.11778 9.84176 6.31301 9.64647C6.50824 9.45117 6.82482 9.45112 7.02012 9.64634L9.16744 11.7929L12.9806 7.97974C13.1759 7.78448 13.4925 7.78448 13.6877 7.97974Z",
    fill: "#5B5C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioColumn);
export default __webpack_public_path__ + "static/media/RadioColumn.d7637f7dbdb4426f264012729c9b0249.svg";
export { ForwardRef as ReactComponent };